<script lang="ts">
	import { editable } from '../editable';
	import type { ISbStoryData } from '@storyblok/js';
	import SimpleImageBlock from './simpleImageBlock.svelte';
	import MuxSbVideo from './muxSbVideo.svelte';
	import Blok from '../blok.svelte';
	import type { SbOverlay } from '../types';
	import { device } from '$lib/state/device.svelte';

	interface Props {
		content: ISbStoryData<{
			asset_mobile: Array<ISbStoryData<SimpleImageBlock | MuxSbVideo>['content']>;
			overlay: SbOverlay;
			asset_desktop: Array<ISbStoryData<SimpleImageBlock | MuxSbVideo>['content']>;
			overlay_desktop: SbOverlay;
		}>['content'];
	}

	let { content }: Props = $props();

	let asset = $derived(
		device.data.isDesktop
			? content.asset_desktop?.[0] || content.asset_mobile?.[0]
			: content.asset_mobile?.[0]
	);
</script>

<div use:editable={content} class="relative h-full">
	{#if asset}
		<Blok content={asset} />

		<div
			class="pointer-events-none absolute inset-0"
			style="background-color: rgba(0, 0, 0, 0.{device.data.isDesktop
				? content.overlay_desktop || 0
				: content.overlay || 0});"
		></div>
	{/if}
</div>
